const ARCHIVED_FARMS_START_PID = -1
const ARCHIVED_FARMS_END_PID = -1

const isArchivedFarmId = (farmId: number) => farmId >= ARCHIVED_FARMS_START_PID && farmId <= ARCHIVED_FARMS_END_PID

export default isArchivedFarmId
